// extracted by mini-css-extract-plugin
export default {"container":"ButtonsAction_container__+YBwm","disabled":"ButtonsAction_disabled__nIWMn","cancel":"ButtonsAction_cancel__U6AHR"};